import React, { useEffect, useState } from "react";
import StablePrime from "../../components/Tables/StablePrime";
import UploadLivoECNFile from "../../components/Upload/UploadLivoECNFile";

 const UploadPlanFile3 = ({ setPageHeader }) =>  {
  const [fileResponse, setFileResponse] = useState();
  if(setPageHeader){
    setPageHeader("Upload ECN");
  }

  return (
    <div>
      <UploadLivoECNFile setFileResponse={setFileResponse} />
      {
        fileResponse && (
          <StablePrime zenTable={true} tableData={fileResponse} />
        )
      }
    </div>
  );
}

export default UploadPlanFile3;
